import styled from 'styled-components';
import { Flexbox, Select, TextField, Typography } from '@hiiretail/synergy-ui';

export const RichTableWrapper = styled(Flexbox)`
  background: #fff;
  border-radius: 8px;
`;

export const PaginationContainer = styled(Flexbox)`
  padding: ${({ theme }) => theme.spacing(4)}px ${({ theme }) => theme.spacing(8)}px;
`;

export const ToolbarWrapper = styled(Flexbox)`
  padding: ${({ theme }) => theme.spacing(8)}px;
  background: #fff;
  border-radius: 8px;
`;

export const ToolbarTitle = styled(Typography)`
  margin-bottom: 0;
`;

export const TableWrapper = styled(Flexbox)`
  padding: 0 ${({ theme }) => theme.spacing(8)}px;
  background: #fff;
  > div {
    display: flex;
    flex: 1 1 auto;
    overflow: hidden;
  }
`;

export const ItemsPerPageSelect = styled(Select)`
  > div {
    bottom: 0;
    > div {
      padding: 2px 3px;
      span {
        font-size: 14px;
      }
    }
  }
`;

export const SearchBar = styled(TextField)`
  background: #eeeeee;
  border-radius: 4px;
  border: none;
  input {
    background: #eeeeee;
    color: #616161;
  }
`;
